module.exports = __webpack_public_path__ + "media/images/logo-f79dc047f2bbcd96dcf56902c4fb9bc0.png";